export default __webpack_public_path__ + "static/media/visa.24e0c44e.svg";